import { ReactElement } from 'react'
import { cn } from 'app/lib/utils'
import { lineDiff, type DiffLine } from './lineDiff'

const DIFF_ROW_STYLES: Record<DiffLine[`type`], string> = {
  add: `bg-green-50 text-green-900`,
  remove: `bg-red-50 text-red-900`,
  context: `text-default`,
}

const DIFF_SIGNS: Record<DiffLine[`type`], string> = {
  add: `+`,
  remove: `-`,
  context: ` `,
}

/** GitHub-style line diff of a prompt body against its previous version. */
export function PromptDiff({ oldBody, newBody }: { oldBody: string; newBody: string }): ReactElement {
  const lines = lineDiff(oldBody, newBody)
  return (
    <div className="overflow-x-auto rounded-md border border-default bg-surface font-mono text-body-xs leading-relaxed">
      {lines.map((line, index) => (
        <div key={index} className={cn(`flex`, DIFF_ROW_STYLES[line.type])}>
          <span className="w-9 shrink-0 select-none px-1.5 text-right text-minimal">{line.oldNumber ?? ``}</span>
          <span className="w-9 shrink-0 select-none px-1.5 text-right text-minimal">{line.newNumber ?? ``}</span>
          <span className="w-4 shrink-0 select-none text-center">{DIFF_SIGNS[line.type]}</span>
          <span className="whitespace-pre-wrap break-words pr-3">{line.text}</span>
        </div>
      ))}
    </div>
  )
}
